/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_The_Ultimate_Photo_For_The_Front_PageInputs */

const en_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the ultimate photo for the front page of your book.`)
};

const es_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona la foto definitiva para la primera página de tu libro.`)
};

const fr_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la photo ultime pour la première page de votre livre.`)
};

const de_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das ultimative Foto für die Titelseite Ihres Buches.`)
};

const ja_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本の最初のページを飾る最高の一枚を選択してください。`)
};

const zh_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为您的书挑选完美的封面照片。`)
};

const ar_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد الصورة المثالية للصفحة الأولى من كتابك.`)
};

const id_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih foto terbaik untuk halaman depan buku Anda.`)
};

const it_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la foto perfetta per la prima pagina del tuo libro.`)
};

const ru_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите идеальную фотографию для первой страницы вашей книги.`)
};

const pt_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a foto perfeita para a primeira página do seu livro.`)
};

const ko_select_the_ultimate_photo_for_the_front_page = /** @type {(inputs: Select_The_Ultimate_Photo_For_The_Front_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책의 첫 페이지를 장식할 최고의 사진을 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Select the ultimate photo for the front page of your book." |
*
* @param {Select_The_Ultimate_Photo_For_The_Front_PageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_the_ultimate_photo_for_the_front_page = /** @type {((inputs?: Select_The_Ultimate_Photo_For_The_Front_PageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_The_Ultimate_Photo_For_The_Front_PageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "es") return es_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "fr") return fr_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "de") return de_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "ja") return ja_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "zh") return zh_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "ar") return ar_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "id") return id_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "it") return it_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "ru") return ru_select_the_ultimate_photo_for_the_front_page(inputs)
	if (locale === "pt") return pt_select_the_ultimate_photo_for_the_front_page(inputs)
	return ko_select_the_ultimate_photo_for_the_front_page(inputs)
});